export default "__VITE_ASSET__DTaj8$bJ__"